// src/components/admin/AdminRooms.jsx
import React, { useEffect, useState } from "react";
import { useAdminApi } from "../../admin/adminApi";

const MEET_BASE = "https://meet.operate.live"; // adjust if needed

const AdminRooms = () => {
  const { getJson, postJson } = useAdminApi();
  const [rooms, setRooms] = useState([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setError("");
      const data = await getJson("/api/rooms");
      setRooms(data.rooms || []);
      setTotal(data.totalRooms || 0);
    } catch (e) {
      console.error("[ADMIN] Failed to fetch rooms:", e);
      setError("Failed to fetch rooms");
    }
  };

  const closeRoom = async (roomId) => {
    if (!window.confirm(`Close room ${roomId}?`)) return;
    try {
      await postJson("/api/rooms/" + encodeURIComponent(roomId) + "/close");
      load();
    } catch (e) {
      console.error("[ADMIN] Close room error:", e);
      alert("Failed to close room");
    }
  };

  // Admin view (observer) – opens with ?observer=1
  const adminView = (roomId) => {
    const url = `${MEET_BASE}/room/${encodeURIComponent(
      roomId
    )}?observer=1`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        borderRadius: 16,
        padding: 12,
        background:
          "linear-gradient(135deg, rgba(15,23,42,0.97), rgba(15,23,42,1))",
        border: "1px solid rgba(148,163,184,0.35)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 8,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Active Rooms ({total})</span>
        <button
          onClick={load}
          style={{
            fontSize: 11,
            borderRadius: 999,
            border: "1px solid rgba(148,163,184,0.6)",
            padding: "2px 8px",
            background: "rgba(15,23,42,0.9)",
            color: "#e5e7eb",
            cursor: "pointer",
          }}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div style={{ fontSize: 11, color: "#f97373" }}>{error}</div>
      )}

      {rooms.length === 0 && !error && (
        <div style={{ fontSize: 12, color: "#9ca3af" }}>
          No active rooms.
        </div>
      )}

      {rooms.length > 0 && (
        <div
          style={{
            maxHeight: 260,
            overflowY: "auto",
            fontSize: 12,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {rooms.map((r) => (
            <div
              key={r.roomId}
              style={{
                padding: 8,
                borderRadius: 10,
                border: "1px solid rgba(55,65,81,0.9)",
                background: "rgba(15,23,42,0.9)",
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: 12, fontWeight: 500 }}>
                  Room: <span style={{ color: "#e5e7eb" }}>{r.roomId}</span>
                </div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>
                  Participants:{" "}
                  <strong>{r.participantsCount || 0}</strong>
                </div>
                {r.participants && r.participants.length > 0 && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "#9ca3af",
                      marginTop: 2,
                      maxWidth: 260,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={r.participants.join(", ")}
                  >
                    {r.participants.join(", ")}
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  alignItems: "flex-end",
                }}
              >
                <button
                  onClick={() => adminView(r.roomId)}
                  style={{
                    fontSize: 11,
                    borderRadius: 999,
                    border: "1px solid rgba(56,189,248,0.8)",
                    padding: "4px 10px",
                    background:
                      "linear-gradient(135deg, rgba(15,23,42,0.95), rgba(56,189,248,0.35))",
                    color: "#e0f2fe",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  👁 Admin view
                </button>

                <button
                  onClick={() => closeRoom(r.roomId)}
                  style={{
                    fontSize: 11,
                    borderRadius: 999,
                    border: "1px solid rgba(248,113,113,0.85)",
                    padding: "4px 10px",
                    background: "linear-gradient(135deg, #ef4444, #b91c1c)",
                    color: "#f9fafb",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  Close room
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminRooms;
